import { Button, Root, Scroll } from './rail.parts';

export const Rail = { Root, Button, Scroll };
